import { useEffect } from 'react';

/**
 * Scrolls the page to an faq node which has the id accociated with a given hash.
 *
 * @param hash - The location hash.
 */
const useScrollToFaq = (hash?: string): void => {
  useEffect(() => {
    if (!hash) {
      return () => {};
    }

    const id = hash.slice(1);

    const timeout = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      // We add a small timeout to make sure the scroll won't be fired too early.
    }, 100);

    return () => {
      clearTimeout(timeout);
    };
  }, [hash]);
};

export default useScrollToFaq;
